import * as React from 'react'

import { StoreComponent, injectStores } from '../../store'
import { observer } from 'mobx-react'

import { ScrollPage, ScrollChildren } from '../common/scrollpage'
import { Cover, ICover } from './cover/cover'
import { Section, ISection } from './book/section'
import { ScrollSidebar } from './book/scrollSidebar'
import { computed } from 'mobx'
import { ContentChapter } from './storydocStoreContent'
import { NextChapterCover } from './book/nextChapterCover'
import { bind } from 'bind-decorator'

interface IProps {
  data: ContentChapter
  slideIdx: number

  goToSection?: string
}

@injectStores
@observer
export class Story extends StoreComponent<IProps> {

  componentDidMount () {
    document.addEventListener('backbutton', this.onBackDown, false)
  }

  componentWillUnmount () {
    document.removeEventListener('backbutton', this.onBackDown, false)
  }

  @bind
  onBackDown (e: any) {
    e.preventDefault()
    e.stopPropagation()
    if (this.activeSlide) {
      if (this.store.storeCommon.menu.open) {
        this.store.storeCommon.menu.open = false
      } else if (this.store.storeCommon.currentStory.vertiefungExpanded) {
        this.store.storeCommon.currentStory.vertiefungExpanded = false
      } else if (this.store.storeCommon.currentStory.timelineExpanded) {
        this.store.storeCommon.currentStory.timelineExpanded = false
      } else if (this.store.storeCommon.currentStory.play) {
        this.store.storeCommon.currentStory.play = false
      } else if (this.store.storyDocUI.currentSlideIdx > 0) {
        this.store.storyDocUI.currentSlideIdx = this.store.storyDocUI.currentSlideIdx - 1
      } else (navigator as any).app.exitApp()
    }
  }

  @computed
  get activeSlide () {
    return this.props.slideIdx === this.store.storyDocUI.currentSlideIdx
  }

  render () {
    const items: (ScrollChildren<ICover> | ScrollChildren<ISection>)[] = [
      { component: Cover, props: { data: this.props.data, active: this.activeSlide } }
    ]

    if (this.props.data) {
      for (const section of this.props.data.sections) {
        items.push({ component: Section, props: { data: this.props.data, section: section, active: this.activeSlide } })
      }
    }

    items.push({ component: NextChapterCover, props: {
      data: this.props.data,
      active: this.activeSlide,
      nextData: this.props.data && this.props.data.idx <= this.store.storyDocContent.chapters.length - 2 ? this.store.storyDocContent.chapters[this.props.data.idx + 1] : null
    } })

    const sidenav = { component: ScrollSidebar, props: { chapter: this.props.data } }

    return (
      <ScrollPage sidenav={sidenav} active={this.activeSlide} slideIdx={this.props.slideIdx}>
        {items}
      </ScrollPage >
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/story.tsx